<body class="material-dashboard-colors">

  <mat-drawer-container appSidebarToggle [@openClose]="isBottomPanelVisible ? 'top' : 'bottom'">
    <mat-drawer #drawer mode="side" position="start" [opened]="uiService.isLeftSidePanelVisible"
      (closedStart)="uiService.hideLeftSidePanel()">
      <header [title]="'Dashboard'"></header>
      <library *ngIf="!editItem"></library>
      <ng-container *ngIf="editItem">
        <edit-playlist *ngIf="editItem.type === libraryEditItemTypes.EditPlaylist" [playlist]="editItem.item">
        </edit-playlist>
        <app-tag-form *ngIf="editItem.type === libraryEditItemTypes.EditTag" [tag]="editItem.item"></app-tag-form>
      </ng-container>
    </mat-drawer>

    <mat-drawer-content>
      <main-content>
        <button class="menu-trigger d-block d-md-none mr-2 mr-md-0" mat-raised-button (click)="drawer.toggle()">
          <mat-icon svgIcon="menu"></mat-icon>
        </button>
      </main-content>
    </mat-drawer-content>

    <mat-drawer class="d-none d-md-block" id="sidenav" position="end" mode="side"
      [opened]="uiService.isRightSidePanelVisible" (closedStart)="uiService.hideRightSidePanel()">
      <playboard></playboard>
    </mat-drawer>
  </mat-drawer-container>

  <mat-toolbar class="footer">
    <bottom-menu [@openClose]="isBottomPanelVisible ? 'open' : 'closed'"></bottom-menu>
  </mat-toolbar>

</body>

<app-evaluation-period-expired></app-evaluation-period-expired>
<app-evaluation-period-notification></app-evaluation-period-notification>